const config = {};

export default config;


// WEBPACK FOOTER //
// ./src/config.js